<template>
  <section class="content-wrapper content-wrapper--full">
    <ag-date-select
      class="ag-statistic__date-select"
      :available-years="[2021, 2020, 2019, 2018, 2017]"
      @quarterSelected="setQuarter($event)"
      @yearSelected="setYear($event)"
    />
    <div class="ag-statistic" v-if="activeStatistic">
      <div class="ag-statistic__header">
        <ag-icon
          class="ag-statistic__logo"
          name="advo-logo"
        />
        <div class="ag-statistic__header-info">
          <p class="ag-statistic__header-text">
            Redaktions-Statistik zu Ihrem Artikel:
          </p>
          <p class="ag-statistic__header-statistics">
            <q> {{ activeStatistic.content.contentHeadline }} </q>
          </p>
        </div>
      </div>
      <div class="ag-statistic__banner">
          <span class="ag-statistic__banner-date">
            <strong>Zeitraum: </strong>
            <span>
              Q{{ this.selectedQuarter }} {{ this.selectedYear }}
            </span>
          </span>
      </div>

      <section class="ag-statistic__section">
        <div class="ag-statistic__card ag-statistic__card--left ag-statistic__card--blue">
          <div class="ag-statistic__content ag-statistic__content--flex-end">
            <ag-icon
              class="ag-statistic__icon ag-statistic__icon--handshake"
              name="handshake"
            />
            <p class="ag-statistic__title ag-statistic__title--no-margin">Ihr Artikel hat</p>
            <p class="ag-statistic__count ag-statistic__count--big">
              {{ getReach }}
            </p>
            <p class="ag-statistic__text">
              potentielle Mandanten erreicht.
            </p>
          </div>
        </div>
        <div class="ag-statistic__card ag-statistic__card--right">
          <div class="ag-statistic__content ag-statistic__content--flex">
            <ag-icon
              class="ag-statistic__icon ag-statistic__icon--keywords"
              name="google-g"
            />
            <p class="ag-statistic__title">
              Top 10 Keywords
            </p>
            <p class="ag-statistic__text">
              Ihr Artikel rankt wie folgt:
            </p>
            <ul class="ag-statistic__list" v-if="activeStatistic.statistic.keywords.length > 0">
              <li
                class="ag-statistic__list-item"
                v-for="(item, index) in activeStatistic.statistic.keywords.slice(0, 10)"
                :key="index"
              >
                <span class="ag-statistic__keyword">{{ item.keyword }}</span>
                <span>{{ item.position }}</span>
              </li>
            </ul>
            <div v-else class="ag-statistic__error">
              Keine Daten verfügbar
            </div>
          </div>
        </div>
      </section>

      <section class="ag-statistic__section ag-statistic__section--slim">
        <div class="ag-statistic__card ag-statistic__card--left">
          <p class="ag-statistic__title">
            <span class="ag-statistic__count ag-statistic__count--readers">
              {{ getReaders }}
            </span>
            <span>
              Leser des Artikels
            </span>
          </p>
          <img
            v-if="activeStatistic.statistic.chartDataReaders"
            class="ag-statistic__chart"
            :src="getReadersChart"
            alt="Leser Diagramm"
          />
          <div v-else class="ag-statistic__error">
            Kein Diagramm verfügbar
          </div>
        </div>
        <div class="ag-statistic__card ag-statistic__card--right">
          <ag-icon
            class="ag-statistic__icon ag-statistic__icon--visits"
            name="screen"
          />
          <p class="ag-statistic__title ag-statistic__title--no-margin">
            Profilaufrufe:
          </p>
          <p class="ag-statistic__count ag-statistic__count--visits">
            {{ getVisits }}
          </p>
          <p class="ag-statistic__text">
            Nutzer haben Ihr AdvoGarant-Profil besucht.
          </p>
        </div>
      </section>

      <section class="ag-statistic__section ag-statistic__section--slim">
        <div class="ag-statistic__card ag-statistic__card--left">
          <p class="ag-statistic__title">
            Woher kamen Ihre Leser?
          </p>
          <img
            v-if="activeStatistic.statistic.chartDataSource"
            class="ag-statistic__chart"
            :src="getSourceChart"
            alt="Quellen Diagramm"
          />
          <div v-else class="ag-statistic__error">
            Kein Diagramm verfügbar
          </div>
        </div>
        <div class="ag-statistic__card ag-statistic__card--right">
          <p class="ag-statistic__title">
            Performance
          </p>
          <img
            v-if="activeStatistic.statistic.chartDataPerformance"
            class="ag-statistic__chart"
            :src="getPerformanceChart"
            alt="Performance Diagramm"
          />
          <div v-else class="ag-statistic__error">
            Kein Diagramm verfügbar
          </div>
        </div>
      </section>
    </div>
    <div class="ag-statistic__loader" v-if="loading"></div>
    <div class="ag-statistic__err-msg" v-if="!activeStatistic">
      <div>
        {{ statusMsg }}
      </div>
      <ag-button
        v-if="errorState"
        class="ag-statistic__button ag-statistic__button--inverted"
        @click="loadStatistic"
      >
        Erneut senden
      </ag-button>
    </div>
  </section>
</template>

<script>
import AgIcon from '@/components/shared/AgIcon.vue';
import AgButton from '@/components/shared/AgButton.vue';
import AgDateSelect from '@/components/shared/AgDateSelect.vue';
import { mapState } from 'vuex';

export default {
  name: 'marketing-statistic',
  metaInfo: {
    title: 'Redaktionsstatistik',
  },
  components: {
    AgIcon,
    AgButton,
    AgDateSelect,
  },
  props: {
    serviceData: {
      type: Object,
      default: null,
      required: false,
    },
    activeServices: {
      type: Array,
      default: null,
      required: false,
    },
    inactiveServices: {
      type: Array,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      id: parseInt(this.$route.params.id, 10),
      activeStatistic: null,
      apiUrl: process.env.VUE_APP_API_ENDPOINT,
      selectedYear: new Date().getFullYear(),
      selectedQuarter: '',
      selectedDuration: '',
      loading: true,
      errorState: false,
      unwatchCustomerId: null,
      statusMsg: 'Ups, da ist etwas schief gelaufen.',
    };
  },
  computed: {
    ...mapState({
      customerId: (state) => state.user.customerId,
    }),
    getReach() {
      return this.formatNumber(this.activeStatistic?.statistic.reach);
    },
    getReaders() {
      return this.formatNumber(this.activeStatistic?.statistic.readers);
    },
    getReadersChart() {
      return this.formatSource(this.activeStatistic?.statistic.chartDataReaders);
    },
    getSourceChart() {
      return this.formatSource(this.activeStatistic?.statistic.chartDataSource);
    },
    getPerformanceChart() {
      return this.formatSource(this.activeStatistic?.statistic.chartDataPerformance);
    },
    getVisits() {
      return this.formatNumber(this.activeStatistic?.statistic.profileVisits);
    },
  },
  mounted() {
    if (this.customerId) {
      this.loadStatistic();
    } else {
      this.unwatchCustomerId = this.$watch('customerId', (newVal, oldVal) => {
        if (newVal !== oldVal) {
          this.loadStatistic();
        }
        this.unwatchCustomerId();
      });
    }
  },
  destroy() {
    if (this.unwatchCustomerId) {
      this.unwatchCustomerId();
    }
  },
  methods: {
    setYear(year) {
      this.selectedYear = year;
      this.loadStatistic();
    },
    setQuarter(quarter) {
      this.selectedQuarter = quarter;
      this.loadStatistic();
    },
    formatNumber(number) {
      return number.toLocaleString('de-DE');
    },
    formatSource(src) {
      return `data:image/svg;base64,${src}`;
    },
    loadStatistic() {
      this.activeStatistic = null;
      this.loading = true;
      this.errorState = false;
      this.statusMsg = 'Die gewünschten Daten werden geladen';
      this.axios(`${this.apiUrl}/customer/${this.customerId}/ag-content/${this.id}/statistics/quarterly/${this.selectedQuarter}/${this.selectedYear}/?imageType=svg&width=492&height=400`)
        .then(({ data }) => {
          this.loading = false;
          this.activeStatistic = data;
        })
        .catch(() => {
          this.loading = false;
          this.errorState = true;
          this.activeStatistic = null;
          this.statusMsg = 'Ups, da ist etwas schief gelaufen.';
        });
    },
  },
};
</script>

<style lang="scss">

.ag-statistic {
  background-color: gray;
  padding: rem(15px);

  @include mq($mq-large) {
    padding: rem(20px);
  }

  &__header {
    width: 100%;
    background-color: $html-bg-color;
    padding: rem(20px);
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;

    @include mq($mq-large) {
      text-align: left;
      flex-direction: row;
      justify-content: space-between;
      height: 150px;
    }
  }

  &__logo {
    height: rem(60px);
    width: rem(150px);
    margin-bottom: rem(20px);

    @include mq($mq-large) {
      width: 250px;
    }
  }

  &__header-info {
    color: $secondary-color;

    @include mq($mq-large) {
      flex-shrink: 0;
      flex-grow: 0;
      flex-basis: calc(60% - 20px);
    }
  }

  &__header-text {
    font-size: rem(17px);
    font-weight: 700;
    line-height: 1.6;
    margin-bottom: rem(10px);

    @include mq($mq-medium) {
      font-size: rem(20px);
    }
  }

  &__header-statistics {
    font-size: rem(17px);
    font-style: italic;
    font-weight: 400;
    color: #2b2e34;
    margin: 0;

    @include mq($mq-medium) {
      font-size: rem(20px);
    }

    @include mq($mq-large) {
      margin: 0 rem(20px);
    }
  }

  &__banner {
    height: 35px;
    width: 100%;
    margin-bottom: 20px;
    background-color: $brand-color;
    color: $html-bg-color;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  &__section {
    width: 100%;
    margin-bottom: 20px;

    @include mq($mq-large) {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    &--slim {

      @include mq($mq-large) {
        height: 450px;
      }
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  &__icon {
    width: rem(100px);
    height: rem(60px);
    margin-bottom: rem(15px);

    @include mq($mq-large) {
      margin-bottom: 0;
      position: absolute;
      right: 0;
      top: 0;
    }

    &--handshake {
      @include mq($mq-large) {
        width: rem(170px);
        height: rem(120px);
      }
    }

    &--keywords {
      @include mq($mq-large) {
        width: 86.559px;
        height: 90.063px;
      }
    }

    &--visits {
      @include mq($mq-large) {
        width: 106.35px;
        height: 113.254px;
        top: 20px;
        right: 70px;
      }
    }
  }

  &__title {
    font-family: $display-font;
    font-size: rem(20px);
    font-weight: 700;
    margin-bottom: rem(15px);

    @include mq($mq-medium) {
      font-size: rem(26px);
    }

    @include mq($mq-large) {
      font-size: rem(28px);
    }

    &--no-margin {
      margin-bottom: 0;
    }
  }

  &__list {
    margin-top: rem(15px);
    margin-bottom: 0;
    list-style: none;
    width: 100%;
    height: 100%;
    padding: 0;
    display: flex;
    text-align: left;
    flex-direction: column;
    justify-content: space-between;
  }

  &__list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid $brand-color;
    padding: rem(5px) 0;
    margin-bottom: rem(5px);
    color: #2b2e34;

    @include mq($mq-large) {
      margin-bottom: 0;
    }
  }

  &__keyword {
    margin-right: rem(20px);
  }

  &__card {
    position: relative;
    display: flex;
    flex-direction: column;
    color: $secondary-color;
    background-color: $html-bg-color;
    width: 100%;
    height: auto;
    padding: rem(20px);
    text-align: center;
    align-items: center;

    @include mq($mq-large) {
      text-align: left;
      align-items: flex-start;
      width: calc(50% - 10px);
    }

    &--left {

      @include mq($mq-large) {
        padding: rem(20px) rem(40px) rem(40px) rem(70px);
      }
    }

    &--right {

      @include mq($mq-large) {
        padding: rem(20px) rem(70px) rem(40px) rem(40px);
      }
    }

    &--blue {
      background-color: $secondary-color;
      color: $html-bg-color;
    }
  }

  &__chart {
    width: 100%;
    max-width: 100%;
    height: 100%;
    display: block;
  }

  &__content {
    font-family: $display-font;
    position: relative;
    width: 100%;
    height: 100%;

    &--flex {
      display: flex;
      flex-direction: column;
      align-items: center;

      @include mq($mq-large) {
        align-items: flex-start;
      }
    }

    &--flex-end {
      display: flex;
      flex-direction: column;
      align-items: center;

      @include mq($mq-large) {
        align-items: flex-start;
        justify-content: flex-end;
      }
    }
  }

  &__text {
    font-family: $display-font;
    font-weight: 700;
    margin: 0;

    @include mq($mq-medium) {
      font-size: rem(18px);
    }

    @include mq($mq-large) {
      font-size: rem(20px);
    }
  }

  &__count {
    font-family: $display-font;
    font-weight: 700;
    margin: 0;
    color: #2b2e34;

    &--visits {
      font-size: rem(30px);

      @include mq($mq-medium) {
        font-size: rem(40px);
      }

      @include mq($mq-large) {
        font-size: rem(55px);
        margin-top: auto;
      }
    }

    &--big {
      font-size: rem(30px);
      color: $html-bg-color;

      @include mq($mq-medium) {
        font-size: rem(40px);
      }

      @include mq($mq-large) {
        font-size: rem(95px);
      }
    }

    &--readers {
      margin-right: rem(15px);
    }
  }

  &__button {
    margin: rem(10px) auto;
    padding: rem(10px);
    border: none;
    border-radius: rem(19px);
    max-width: rem(200px);
    background-color: #3169AA;

    &--inverted {
      background-color: #fff;
      border: 2px solid $secondary-color;
      margin: rem(50px) auto;
    }
  }

  &__error {
    margin-top: auto;
    font-weight: 600;
    font-family: $copy-font;
  }

  &__date-select {
    display: flex;
    justify-content: center;
    margin-bottom: rem(20px);
  }

  &__err-msg {
    text-align: center;
    font-family: $copy-font;
    font-size: rem(18px);
    font-weight: 600;
    margin: rem(20px) 0;
  }

  &__loader {
    border: 10px solid #f3f3f3;
    border-top-color: $secondary-color;
    border-radius: 50%;
    width: rem(80px);
    height: rem(80px);
    margin: rem(20px) auto;
    animation: spin 2s linear infinite;

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  }
}

</style>
